import { BaseRouteService } from 'core/services';

class InsuranceRouteService extends BaseRouteService {
    constructor() {
        super('local-insurances');
    }

    find(filter) {
        return super.find(this.base + '/{?searchQuery,page,rpp,sort,embed,fields,isPrimarySort,isNiko,isActive}', filter);
    }

    get(id, options) {
        return super.get(this.base + '/{id}/{?embed,fields}', id, options);
    }

    create(resource) {
        return super.create(this.base, resource);
    }

    update(resource) {
        return super.update(this.base + '/{id}', resource);
    }

    batchUpdate(resource) {
		return super.batchUpdate(`${this.base}/batch`, resource);
	}

    delete(resource) {
        return super.delete(this.base + '/{id}', resource);
    }

    download(filter) {
        return super.find(this.base + '/download/{?searchQuery,rpp,page,sort}', filter);    
    }

    upload(resource){
        return super.create(this.base + '/upload', resource);
    }

    sync(){
        return super.update(this.base + '/sync');
    }

    nikoSync(){
        return super.update(this.base + '/niko-sync');
    }
}

export default InsuranceRouteService;
